import { z } from 'zod';

const envSchema = z.object({
  DEV: z.boolean().optional().default(false), // In prduction this will be undefined
  VITE_HOST_FRONTEND: z.url(),
  VITE_HOST_BACKEND_HTTP: z.url(),
  VITE_HOST_BACKEND_WS: z.string().min(1),
});

// Safe-parse environment variables
const env = envSchema.parse(import.meta.env);

// Export environment variables
export const isDev = env.DEV;

export const backend = {
  url: env.VITE_HOST_BACKEND_HTTP,
  wsUrl: env.VITE_HOST_BACKEND_WS,
};

export const frontend = {
  host: env.VITE_HOST_FRONTEND,
};
